import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String, // URL to submit form
    method: { type: String, default: 'POST' }, // Request type
  }

  // initializations are done here, after connecting
  connect() {}

  // Called whenever you use this.formData
  get formData() {
    let data = new FormData(this.element)
    data.delete('_method') // Remove request type of original form
    return data
  }

  // Called whenever you use this.ignoredInputIds
  get ignoredInputIds() {
    return []
  }

  // Called whenever you use this.debouncedInputIds
  get debouncedInputIds() {
    return []
  }

  preSubmit(event, ...callbacks) {
    if (this.ignoredInputIds.includes(event?.target?.id)) {
      return
    }

    const submitFn = async () => {
      this.abortController?.abort()
      // https://developer.mozilla.org/en-US/docs/Web/API/AbortController
      const abortController = new AbortController()
      this.abortController = abortController

      // rails requires a CSRF token to validate any non-GET request
      const csrfToken = document.querySelector("[name='csrf-token']").content

      try {
        // Submit the form data
        const response = await fetch(this.urlValue, {
          credentials: 'include',
          method: this.methodValue,
          headers: {
            'x-csrf-token': csrfToken,
          },
          body: this.formData,
          signal: abortController.signal,
        })

        // Run any callbacks given
        callbacks.forEach((callback) => callback(response))
      } catch (error) {
        console.error(error)

        this.dispatch('error', { detail: { error } })

        throw error
      } finally {
        // Only give up the shared field if it still points at this request. An
        // aborted request settles after its successor has already claimed the
        // field, and clearing it unconditionally orphaned that successor: the
        // next submit found null, aborted nothing, and left two requests in
        // flight racing to apply their responses.
        if (this.abortController === abortController) {
          this.abortController = null
        }
      }
    }

    if (this.debouncedInputIds.includes(event?.target?.id)) {
      // If a submission is scheduled, cancel it and schedule a new one
      clearTimeout(this.timeout)

      // Schedule a new submission
      this.timeout = setTimeout(submitFn, 500)

      return
    }

    submitFn()
  }
}
